module.exports = __webpack_public_path__ + "static/media/address.29fafde1.png";